import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { ChartDefinition } from 'src/shared/models/chart-definintions.model';
import { Chart } from 'angular-highcharts';
import { ReportService } from 'src/shared/services/report.service';
import { ReportData } from 'src/shared/models/report-data.model';
import { Observable, from, Subscription } from 'rxjs';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { MiscUtil } from 'src/shared/utilities/misc.util';

@Component({
  selector: 'smt-reasons-for-variance-drilldown-report',
  templateUrl: './reasons-for-variance-drilldown-report.component.html',
  styleUrls: ['./reasons-for-variance-drilldown-report.component.scss']
})
export class ReasonsForVarianceDrillDownReportComponent implements OnInit {

  reasonsForVarianceDrillDownChart : Chart;
  reasonsForVarianceData: ReportData;
  chartDefinition: ChartDefinition = new ChartDefinition();
  loading:boolean;
  reportSubscription : Subscription;

  private expandEventsSubscription: any;
  private filterEventSubscription: any;

  @Input() filtersUpdated: Observable<void>;
  @Input() reportFilters:ReportFilters;

  @Output() reasonsForVarianceDataUpdated = new EventEmitter();
  constructor(private _reportService:ReportService) { }

  ngOnInit() {
    this.drawEmpty();
    this.loading = true;
    if (this.filtersUpdated)
      this.filterEventSubscription = this.filtersUpdated.subscribe(() => this.getData());
  }

  drawEmpty()
  {
    this.reasonsForVarianceDrillDownChart = this.chartDefinition.getLineTemplate
    (
      `Reasons for Variance by ${this.reportFilters.ReportView}`,
      this.reportFilters.ReportView,
      'Variance Count',
      []
    );
  }

  drawGrid()
  {
    this.loading = false;
    const minRows:number = 5;

    if(!this.reasonsForVarianceData)
      return;

    let chartData = MiscUtil.getDataFilteredByDataSetName(this.reasonsForVarianceData);

    this.reasonsForVarianceDrillDownChart = this.chartDefinition.getLineTemplate
      (
        `Reasons for Variance by ${this.reportFilters.ReportView}`,
        this.reportFilters.ReportView,
        'Variance Count',
        this.reasonsForVarianceData.xAxis
      );

    if (chartData.length == 0)
      return;

    let chartSizeMinusOne = chartData.length - 1;

    // Add all but the last entry with the re-draw flag set to false this speeds up chart drawing
    chartData.slice(0,chartSizeMinusOne).forEach(dataSet =>
      {
        this.reasonsForVarianceDrillDownChart.addSeries({type: 'line', name: dataSet.name, 	data:  dataSet.data},false,true);
      });

    this.reasonsForVarianceDrillDownChart.addSeries({type: 'line', name: chartData[chartSizeMinusOne].name, 	data:  chartData[chartSizeMinusOne].data},true,true);

  }

  async getData()
  {
    this.loading = true;

    if(this.reportSubscription)
      this.reportSubscription.unsubscribe();

    this.reportSubscription = from(this._reportService.getReasonsForVarianceReport(this.reportFilters))
                                .subscribe(x => {
                                    this.reasonsForVarianceData = x;
                                    this.reasonsForVarianceDataUpdated.emit(this.reasonsForVarianceData);
                                    this.drawGrid();
                                });                 
  }

  ngOnDestroy() {
    if(this.filtersUpdated)
      this.filterEventSubscription.unsubscribe();
    if(this.reportSubscription)
      this.reportSubscription.unsubscribe();
  }
}
